<h1 mat-dialog-title>
  <span>{{ 'k002776' | translate }}</span>
  <!-- Token: Advertencia de riesgo -->
  <div mat-button (click)="goOut()" class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content>
  <button class="autofocusHidden" autofocus></button>
  <!-- este boton es pra forzarle a que haga focus en el modal porque sino en movil siempre se abre abajo -->
  <div [innerHTML]="'k002777' | translate"></div>
  <!-- token: La cartera seleccionada no parece apropiada por alguna de las siguientes
  razones:<br />
  <br />
  <ul>
    <li>La cartera tiene un nivel de riesgo superior a tu perfil de riesgo.</li>
    <li>
      Tras analizar tu capacidad para asumir riesgos, consideramos que tu perfil
      no es adecuado para la cartera elegida.
    </li>
  </ul>
  <br />
  Es posible que te sientas incómodo con la volatilidad de esta cartera. Una
  mayor volatilidad implica que tu inversión sufrirá subidas y bajadas a corto
  plazo. Si inviertes a corto plazo, existe un mayor riesgo de obtener una
  rentabilidad inferior a la esperada.
  <br />
  <br />
  Si decides seleccionar esta cartera, de un nivel superior a tu perfil de
  riesgo, haz click en el siguiente aviso legal:
  <br /> -->
  <form [formGroup]="form" class="form-login fadeIn">
    <div class="modalOutstanding">
      <mat-checkbox
        class="checkNoExpiry ml-3 mt-3"
        name="iAgree"
        formControlName="iAgree"
        value="false"
      >
      </mat-checkbox>
      {{ 'k002778' | translate }}
      <!-- token: Acepto invertir en esta cartera de un nivel de riesgo más alto que mi
      perfil de riesgo. Entiendo que estoy asumiendo riesgos adicionales en mis
      inversiones. También acepto que Bulltick me ha informado adecuadamente
      sobre los riesgos adicionales que asumo. -->
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="buttonContainer w-100">
    <button
      type="button"
      class="buttonPortal lg cancel my-4"
      mat-raised-button
      (click)="goOut()"
    >
      <span>{{ 'k000225' | translate }}</span>
      <!-- Token: Cancel -->
    </button>
    <button
      #btnNext
      type="button"
      class="buttonPortal lg my-4"
      mat-raised-button
      [disabled]="!form.value.iAgree"
      (click)="goNext()"
    >
      <span>{{ 'k000226' | translate }}</span>
      <!-- Token: Continuar -->
    </button>
  </div>
</div>
